import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import PageLoading from "../../../components/Loading/PageLoading";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import _ from "lodash";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";

import {
  exportNewCustomer,
  filterNewCustomer,
  listAllCustomers,
} from "./component/NewCustomerForm/NewCustomerData";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/LodingContext";
import { downloadExcelFile } from "../../function/downloadExcel";
import URL from "../../../pages/Utils/url";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";

import {
  newcustomerState,
  newCustomerStateMange,
} from "./component/NewCustomerForm/newCustomerState";
import RoleAccess from "../../function/RoleAccess";
import RefreshIcon from "@mui/icons-material/Refresh";

const NewCustomer = () => {
  const navigate = useNavigate();
  const [newCustomerData, dispatch] = useReducer(
    newCustomerStateMange,
    newcustomerState
  );
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const { setCirleLoading } = useLoading();
  const [error] = useState("");

  useEffect(() => {
    if (newCustomerData?.fromDate && newCustomerData?.toDate) {
      fetchFilteredProducts(newCustomerData?.fromDate, newCustomerData?.toDate);
    }
  }, [newCustomerData?.fromDate, newCustomerData?.toDate]);

  useEffect(() => {
    fetchAllTaskList();
  }, []);
  const newCustomerListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Customer Category",
        field: "customerCategory",
        name: "customerCategory",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Customer Code",
        field: "customerCode",
        name: "customerCode",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        name: "customerName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created On",
        field: "createdOn",
        name: "createdOn",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Price Code",
        field: "priceCode",
        name: "priceCode",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,

        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      customerCategory: _.capitalize(v?.customerCategory),
      customerCode: _.capitalize(v?.customerCode),
      customerName: _.capitalize(v?.customerName),
      priceCode: v?.priceCode,
      createdBy: v?.user?.employeeName,
      createdOn: v?.createdAt.slice(0, 10),
      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="New Customer Screen"
            component="ViewNewCustomer"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => {
                if (v?.id) {
                  navigate(`/newcustomer/view-new-customer?id=${v?.id}`);
                }
              }}
            />
          </RoleAccess>

          <RoleAccess
            modelName="New Customer Screen"
            component="UpdateNewCustomer"
          >
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => {
                if (v?.id) {
                  navigate(`/newcustomer/edit-new-customer?id=${v?.id}`);
                }
              }}
            />
          </RoleAccess>

          {/* <DeleteIcon
                    style={{ color: "GrayText", fontSize: "20px" }}
                    onClick={() => handleDelte(v?.id)}
                  /> */}
        </div>
      ),
    })),
  };
  const fetchAllTaskList = () => {
    request(BASEURL, listAllCustomers)
      .then((res) => {
        const allCustomerData = res.allCustomerDetails?.data || [];
        setData(allCustomerData);
      })
      .catch((err) => {
        console.error("Failed to fetch task progress data", err);
        setData([]);
      });
  };

  const onCustomerEditClick = (e) => {
    if (e?.id) {
      navigate(`/newcustomer/view-new-customer?${e?.id}`);
    }
  };
  //download excel file
  const handleDownload = (fromDate, toDate) => {
    setCirleLoading(true);
    request(BASEURL, exportNewCustomer, {
      fromDate,
      toDate,
    }).then(async (res) => {
      const status = res?.exportCustomers?.success;

      const pdfurl = `${URL}${res?.exportCustomers?.fileUrl?.slice(1)}`;

      if (status) {
        const status = await downloadExcelFile(
          pdfurl,
          "realtime_inventory.xlsx"
        );
        setCirleLoading(false);
      }
    });
  };
  //filter api call
  const fetchFilteredProducts = (fromdate, todate) => {
    setIsLoading(true);

    request(BASEURL, filterNewCustomer, {
      fromdate,
      todate,
    })
      .then((res) => {
        const newdata = res?.filterCustomerDateRange?.data;
        setData(newdata);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const resetFilters = () => {
    dispatch({ value: "", name: "fromDate" });

    dispatch({ value: "", name: "toDate" });
    fetchAllTaskList();
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  New Customer List
                </MaterialTypography>
              </Stack>
              {newCustomerData?.fromDate && newCustomerData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(
                      newCustomerData?.fromDate,
                      newCustomerData?.toDate
                    );
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}

              <RoleAccess
                modelName="New Customer Screen"
                component="CreateNewCustomer"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/newcustomer/add-new-customer", {
                      state: { type: "add" },
                    })
                  }
                >
                  New Customer
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        <Box sx={{ my: "5px" }}>
          <Grid container spacing={2} p={1}>
            <Grid size={{ xs: 12, sm: 2.5 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  From Date
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="date"
                size="small"
                name="fromDate"
                value={newCustomerData?.fromDate}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "fromDate" })
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2.5 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  To Date
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="date"
                size="small"
                name="toDate"
                value={newCustomerData?.toDate}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "toDate" })
                }
              />
              {error && (
                <MaterialTypography
                  color="error"
                  variant="caption"
                  display="block"
                  mt={1}
                >
                  {error}
                </MaterialTypography>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 2 }}>
              <IconButton
                onClick={resetFilters}
                aria-label="Reset Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <RefreshIcon fontSize="large" />
              </IconButton>
            </Grid>
          </Grid>
        </Box>

        <MaterialDataGrid
          // customHeight={550}
          rows={newCustomerListTable?.rows}
          columns={newCustomerListTable?.columns}
          // checkboxSelection={false}
          isSelectable={false}
          // onRowClick={onCustomerListClick}
          //   loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No New Customer found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any customer details. Click on the "Add
                  New Customer" button to start adding New customer details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default NewCustomer;
